export enum MaskPatterns {
  PHONE_NUMBER = '000-000-0000',
}
